import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
import {WaTagDirective} from 'angular-awesome';
@Component({
	selector:'jwebmp-pcomp-ag-grid',
	templateUrl:'./AgGridPluginCompPage.html',
	styles: [],
	styleUrls:['./AgGridPluginCompPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
		WaTagDirective,
],
	standalone:true
})
export class AgGridPluginCompPage
{
	mdContent_737 = `\`\`\`java
import com.jwebmp.plugins.aggrid.AgGrid;
\`\`\``;
	mdContent_738 = `\`\`\`java
AgGrid()
\`\`\``;
	mdContent_739 = `\`\`\`java
public class OrderGrid extends AgGrid&lt;OrderGrid&gt; {
    public OrderGrid() {
        setHeight("600px")
            .enablePagination()
            .enableRowSelection(RowSelectionMode.multiRow);

        addColumnDef(new AgGridColumnDef&lt;&gt;()
            .setField("orderId")
            .setHeaderName("Order ID")
            .setWidth(100));

        addColumnDef(new AgGridColumnDef&lt;&gt;()
            .setField("total")
            .setHeaderName("Total")
            .setFlex(1));
    }

    @Override
    public String getRowIdFieldName() {
        return "orderId";
    }

    @Override
    public Collection fetchData() {
        return orderService.findAll();
    }
}
\`\`\``;
	mdContent_740 = `\`\`\`java
AgGridColumnDef&lt;?&gt; col = new AgGridColumnDef&lt;&gt;("status", "Status");
configureCellRenderer(col, new StatusBadgeRenderer());
addColumnDef(col);
\`\`\``;
}
